export default __webpack_public_path__ + "static/media/round-table.4dcca365.png";